import React from 'react';
import classNames from 'classnames';
import { Button, Modal } from '@alfa-retail-react/components';
import 'app/component/download-error-modal/DownloadErrorModal.less';

export interface DownloadErrorModalProps {
    /**
     * Признак десктопного разрешения окна браузера.
     *
     * true - десктопный режим.
     */
    isDesktop: boolean;

    /**
     * Признак открытия.
     */
    open: boolean;

    /**
     * Скачивание файла.
     */
    onDownload: () => void;

    /**
     * Закрытие модального окна.
     */
    onClose: () => void;

    /**
     * CSS класс.
     */
    className?: string;

    /**
     * Признак процесса загрузки.
     */
    isDownloading?: boolean;
}

/**
 * Компонент модального окна ошибки скачивания файла.
 */
export const DownloadErrorModal = (props: DownloadErrorModalProps) => (
    <Modal
        isDesktop={props.isDesktop}
        className={classNames('downloadErrorModal', props.className)}
        title="Не удалось загрузить документ"
        open={props.open}
        onClose={props.onClose}
        content="Пожалуйста, проверьте подключение к интернету и попробуйте ещё раз"
        actionButton={
            <Button
                className="confirm"
                view="accent"
                size="s"
                onClick={props.onDownload}
                disabled={props.isDownloading}
                block
            >
                Попробуйте ещё раз
            </Button>
        }
    />
);
